module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-230.a162867b.svg";